import {CoreBaseEffects} from "@core/core-base.effects";
import {Observable} from "rxjs";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {Store} from "@ngrx/store";
import {TechInfosActions} from "@tech/pages/infos/store/tech-info.actions-type";
import {Injectable} from "@angular/core";
import {ISharedLocalBodyRequest} from "@shared/interfaces/shared-local-body-request.interface";
import {ILocalRequestPayload} from "@shared/interfaces/local-request-payload.interface";

@Injectable({
  providedIn: 'root'
})
export abstract class TechInfoEffectsBase extends CoreBaseEffects {

  protected constructor(store: Store, rawActions$: Actions) {
    super(store, rawActions$);
  }

  abstract getInfoList(action$: Observable<ILocalRequestPayload>): Observable<any>;

  abstract postMyRead(action$: Observable<any>): Observable<any>;

  getInfoList$ = createEffect(() => this.actions().pipe(
    ofType(TechInfosActions.getInfoList),
    action => this.getInfoList(action)
  ));

  postMyRead$ = createEffect(() => this.actions().pipe(
    ofType(TechInfosActions.postItemsMyRead),
    action => this.postMyRead(action)
  ));

}
